import React, { FC } from 'react'
import Icon, { IconType } from '@bt-react/components/Icon'
import ConfirmModal, { ConfirmModalProps } from '@bt-react/components/ConfirmModal'
import style from './WarningModal.module.scss'

interface WarningModalProps extends Omit<ConfirmModalProps, 'content'> {
  headerText: string
  body: JSX.Element
  confirmationText: string
}

const WarningModal: FC<WarningModalProps> = ({ onCancel, onConfirm, headerText, isOpen = false, body, confirmationText }) => {

  return <ConfirmModal
    className={style['WarningModal__confirm__modal']}
    isOpen={isOpen}
    content={{
      header: <div className={style['WarningModal__modal__header']}>
        <Icon name={IconType.iconName.danger} colour={IconType.colour.white} /> {headerText}
      </div>,
      body: <div className={style['WarningModal__modal_body']}>{ body }</div>,
      confirmBkgColour: IconType.colour.primary,
      confirm: confirmationText,
      confirmClassName: style['WarningModal__confirm__modal__button']
    }}
    onCancel={onCancel}
    onConfirm={onConfirm}
    type='warning'
  />

}

export default WarningModal
